// @flow

export default () => ({
    delay: 20,
    input: 20,
    noise: 4,
    min: 0,
    max: 63,
    zoom: 1,
    amount: 1,
    noisefloor: 4,
    glide: 1,
    smooth: 1,
    settle: 1,
    glideEnabled: false,
    smoothEnabled: true,
    settleEnabled: true,
    doubleReadEnabled: false,
    pin: true,
    play: true
});



// WEBPACK FOOTER //
// ./src/demo/DemoState.js